import React, { useEffect, useState, useMemo, useCallback } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Checkbox, FormControlLabel, FormGroup, Grid, TextField } from '@mui/material';
import CheckboxItem from './CheckboxItem2';
import debounce from 'lodash.debounce';



const FilterAccordion = React.memo((props) => {
	let { onChangeCategory, selectedList = [], qualificationList = [], levels, 
		showTwoColumns = true, includeTeacherCategory = false, isChildcareCentre = false } = props
	const [showDetail, setShowDetail] = useState({})
	const [searching, setSearching] = useState({})

	// let countItem = {}
	const mapSelectedList = (selectedList) => {
		return selectedList?.map(item => {
			return item?.split("_id:")?.[0]
		}) || []
	}

	const newSelectedList = useMemo(() => {
		return mapSelectedList(selectedList)
	}, [selectedList])

	const countChecked = (selectedList, currentCategories) => {
		const countResult = {};
		for (const category of currentCategories) {
			const qualifications = category.qualifications;
			for (const item of qualifications) {
				if (newSelectedList.includes(item._id)) {
					if (category.type === 'vet') {
						countResult[category._id] = (countResult[category._id] || 0) + 1;
						countResult[category.type] = (countResult[category.type] || 0) + 1;
						countResult[item._id] = (countResult[item._id] || 0) + 1;
						countResult[`vet_${category._id}_level_${item.level}`] = (countResult[`vet_${category._id}_level_${item.level}`] || 0) + 1;
					}
					else {
						countResult[category._id] = (countResult[category._id] || 0) + 1;
						countResult[category.type] = (countResult[category.type] || 0) + 1;
					}
					
				}
				else {
					if (category.type === 'vet') {
						const { units } = item
						for (const unit of units) {
							if (selectedList.includes(unit._id)) {
								countResult[category._id] = (countResult[category._id] || 0) + 1;
								countResult[category.type] = (countResult[category.type] || 0) + 1;
								countResult[item._id] = (countResult[item._id] || 0) + 1;
								countResult[`vet_${category._id}_level_${item.level}`] = (countResult[`vet_${category._id}_level_${item.level}`] || 0) + 1;
							}
						}
					}
				}
			}
		}
		return countResult
	};

	const countItem = useMemo(() => {
		return countChecked(selectedList, qualificationList)
	}, [selectedList, qualificationList]);

	const memoizedOnChangeCategory = useCallback((event, qua = null, rootID) => {
		onChangeCategory(event, qua, rootID);
	}, [onChangeCategory]);

	

	const onShowing = (key, expanded = false) => {
		setShowDetail({
			...showDetail,
			[key]: expanded
		})
	}

	const debouncedOnChange = debounce((value, id) => {
        setSearching({
        ...searching,
        [id]: value
        });
    }, 300);

	const handleInputChange = (e, qua) => {
        const { value } = e.target;
        debouncedOnChange(value, qua._id);
    };

	return (
		<div>
			{
				isChildcareCentre ? (
					<Accordion onChange={(event, expanded) => onShowing('ecec', expanded)}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel3a-content"
							id="panel3a-header"
						>
							<Typography sx={{ width: '70%', flexShrink: 0 }}>Early Childhood Education & Care (ECEC)</Typography>
							<Typography sx={{ color: 'primary.main' }}>{countItem['ecec'] ? `${countItem['ecec']} item(s) selected` : ''}</Typography>
						</AccordionSummary>
						{ showDetail['ecec'] && <AccordionDetails>
							{qualificationList.filter(item => item.type === 'ecec').map((item, index) => {
								return (
									<Accordion onChange={(event, expanded) => onShowing(`ecec_${item._id}`, expanded)} className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls="panel1a1-content"
											id="panel1a1-header"
										>
											<Typography sx={{ width: '70%', flexShrink: 0 }}>{item.qualification_name}</Typography>
											<Typography sx={{ color: 'primary.main' }}>{countItem[item._id] ? `${countItem[item._id]} item(s) selected` : ''}</Typography>
										</AccordionSummary>
										{showDetail[`ecec_${item._id}`] && <AccordionDetails>
											<FormGroup>
												<Grid container spacing={2}>
													{item.qualifications
														// .filter((item) => item.type.includes('ge') && !item.whole_name.includes('All Levels'))
														.map((ele, indexEle) => {
															const shouldChecked = selectedList.includes(ele._id) ? true : false;

															return (
																<Grid item key={indexEle} xs={showTwoColumns ? 6: 12} style={{"paddingTop": "4px", textAlign: 'left'}}>
																	<CheckboxItem ele={ele} shouldChecked={shouldChecked} onChange={(e) => memoizedOnChangeCategory(e)}/>
																</Grid>
															);
														})}
												</Grid>
											</FormGroup>
										</AccordionDetails>}
									</Accordion>
								)
							})}
						</AccordionDetails>
						}
					</Accordion>
				) : (
					<>
						<Accordion onChange={(event, expanded) => onShowing('elt', expanded)}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography sx={{ width: '70%', flexShrink: 0 }}>English Language (ELT/ELICOS)</Typography>
								<Typography sx={{ color: 'primary.main' }}>{countItem['elt'] ? `${countItem['elt']} item(s) selected` : ''}</Typography>
							</AccordionSummary>
							{ showDetail['elt'] && <AccordionDetails>

								{qualificationList.filter(item => item.type === 'elt').sort((a, b) => {
									return a.qualification_name === 'General English' ? -1 : 1;
								}).map((item, index) => {
									return (
										<Accordion onChange={(event, expanded) => onShowing(`ele_${item._id}`, expanded)} className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
											<AccordionSummary
												expandIcon={<ExpandMoreIcon />}
												aria-controls="panel1a1-content"
												id="panel1a1-header"
											>
												<Typography sx={{ width: '70%', flexShrink: 0 }}>{item.qualification_name}</Typography>
												<Typography sx={{ color: 'primary.main' }}>{countItem[item._id] ? `${countItem[item._id]} item(s) selected` : ''}</Typography>
											</AccordionSummary>
											{ showDetail[`ele_${item._id}`] && <AccordionDetails>
												<FormGroup>
													<Grid container spacing={2}>
														{item.qualifications
															// .filter((item) => item.type.includes('ge') && !item.whole_name.includes('All Levels'))
															.map((ele, indexEle) => {
																const shouldChecked = newSelectedList.includes(ele._id) ? true : false;

																return (
																	<Grid item key={indexEle} xs={showTwoColumns ? 6: 12} style={{"paddingTop": "4px", textAlign: 'left'}}>
																		<CheckboxItem ele={ele} shouldChecked={shouldChecked} onChange={(e) => memoizedOnChangeCategory(e)}/>
																	</Grid>
																);
															})}
													</Grid>
												</FormGroup>
											</AccordionDetails>
											}
										</Accordion>
									)
								})}
							</AccordionDetails>
							}
						</Accordion>

						<Accordion onChange={(event, expanded) => onShowing('vet', expanded)}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel2a-content"
								id="panel2a-header"
							>
								<Typography sx={{ width: '70%', flexShrink: 0 }}>Vocational (VET)</Typography>
								<Typography sx={{ color: 'primary.main' }}>{countItem['vet'] ? `${countItem['vet']} item(s) selected` : ''}</Typography>
							</AccordionSummary>
							{ showDetail['vet'] && <AccordionDetails>
								{qualificationList.filter(item => item.type === 'vet').map((item, index) => {
									return (
										<Accordion onChange={(event, expanded) => onShowing(`vet_${item._id}`, expanded)} className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
											<AccordionSummary
												expandIcon={<ExpandMoreIcon />}
												aria-controls="panel1a1-content"
												id="panel1a1-header"
											>
												<Typography sx={{ width: '70%', flexShrink: 0 }}>{item.qualification_name} {`${item.code ? `(${item.code})` : ''}`}</Typography>
												<Typography sx={{ color: 'primary.main' }}>{countItem[item._id] ? `${countItem[item._id]} item(s) selected` : ''}</Typography>
											</AccordionSummary>
											{showDetail[`vet_${item._id}`] && <AccordionDetails>
												{
													levels.map(level => {
														
														return (
															<Accordion onChange={(event, expanded) => onShowing(`vet_${item._id}_${level}`, expanded)} className='my-2' style={{ backgroundColor: "#ffffff" }}>
																<AccordionSummary
																	expandIcon={<ExpandMoreIcon />}
																	aria-controls="panel1a1-content"
																	id="panel1a1-header"
																>
																	<Typography sx={{ width: '70%', flexShrink: 0 }}>{level}</Typography>
																	<Typography sx={{ color: 'primary.main' }}>{countItem[`vet_${item._id}_level_${level}`] ? `${countItem[`vet_${item._id}_level_${level}`]} item(s) selected` : ''}</Typography>
																</AccordionSummary>
																{showDetail[`vet_${item._id}_${level}`] && <AccordionDetails>
																	{item.qualifications.filter(qua => qua.level === level)
																		.map((qua, indexQua) => {
																			return (
																				<Accordion onChange={(event, expanded) => onShowing(`vet_${item._id}_${level}_qua_${qua._id}`, expanded)} className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
																					<AccordionSummary
																						expandIcon={<ExpandMoreIcon />}
																						aria-controls="panel1a1-content"
																						id="panel1a1-header"
																					>
																						<Typography sx={{ width: '70%', flexShrink: 0 }}>{qua.title}</Typography>
																						<Typography sx={{ color: 'primary.main' }}>{countItem[qua._id] ? `${countItem[qua._id]} item(s) selected` : ''}</Typography>
																					</AccordionSummary>
																					{showDetail[`vet_${item._id}_${level}_qua_${qua._id}`] && <AccordionDetails>
																						

																						<FormGroup>
																							<Grid container spacing={2}>
																								{qua.units.slice(0,1)
																									.map((ele, indexEle) => {
																										const shouldChecked = selectedList.includes(ele._id) ? true : false;
																										return (
																											<Grid item key={indexEle} xs={showTwoColumns ? 6: 12} style={{"paddingTop": "4px", textAlign: 'left'}}>
																												<CheckboxItem ele={ele} qua={qua} shouldChecked={shouldChecked} onChange={(e) => memoizedOnChangeCategory(e, qua, qua.units?.[0]._id)}/>
																											</Grid>
																										);
																									})}
																							</Grid>
																						</FormGroup>

																						<h4 className='my-2'>OR</h4>
																						<p className='my-2'>Specify Course Unit (Choose multiple)</p>
																						{qua.units.length > 10 && (
																							<TextField 
																								id="standard-basic" 
																								label="Search for an unit" 
																								variant="standard"
																								className='mb-4' 
																								fullWidth
																								onChange={(e) => handleInputChange(e, qua)}
																							/>
																						)}
																						<FormGroup>
																							<Grid container spacing={2}>
																								{qua.units
																									.slice(1)
																									.filter(item => 
																										!searching[qua._id]?.length || 
																										item.title.toLowerCase().includes(searching[qua._id].toLowerCase()) ||
																										item.code.toLowerCase().includes(searching[qua._id].toLowerCase())
																									)
																									.map((ele, indexEle) => {
																										const shouldChecked = 
																											selectedList.includes(ele._id) && 
																											!selectedList.includes(qua.units?.[0]._id)  
																										? true : false;
																																																	
																										return (
																											<Grid item key={indexEle} xs={showTwoColumns ? 6: 12} style={{"paddingTop": "4px", textAlign: 'left'}}>
																												<CheckboxItem ele={ele} qua={qua} shouldChecked={shouldChecked} onChange={(e) => memoizedOnChangeCategory(e, qua, qua.units?.[0]._id)}/>
																											</Grid>
																										);
																									})}
																							</Grid>
																						</FormGroup>
																					</AccordionDetails> 
																					}
																				</Accordion>
																			)
																		})}
																</AccordionDetails>}
															</Accordion>
														)
													})
												}
											</AccordionDetails>}
										</Accordion>
									)
								})}
							</AccordionDetails>
							}
						</Accordion>

						<Accordion onChange={(event, expanded) => onShowing('smes', expanded)}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel3a-content"
								id="panel3a-header"
							>
								<Typography sx={{ width: '70%', flexShrink: 0 }}>Specialist area (SMEs)</Typography>
								<Typography sx={{ color: 'primary.main' }}>{countItem['smes'] ? `${countItem['smes']} item(s) selected` : ''}</Typography>
							</AccordionSummary>
							{ showDetail['smes'] && <AccordionDetails>
								{qualificationList.filter(item => item.type === 'smes').map((item, index) => {
									return (
										<Accordion onChange={(event, expanded) => onShowing(`smes_${item._id}`, expanded)} className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
											<AccordionSummary
												expandIcon={<ExpandMoreIcon />}
												aria-controls="panel1a1-content"
												id="panel1a1-header"
											>
												<Typography sx={{ width: '70%', flexShrink: 0 }}>{item.qualification_name}</Typography>
												<Typography sx={{ color: 'primary.main' }}>{countItem[item._id] ? `${countItem[item._id]} item(s) selected` : ''}</Typography>
											</AccordionSummary>
											{showDetail[`smes_${item._id}`] && <AccordionDetails>
												<FormGroup>
													<Grid container spacing={2}>
														{item.qualifications
															// .filter((item) => item.type.includes('ge') && !item.whole_name.includes('All Levels'))
															.map((ele, indexEle) => {
																const shouldChecked = selectedList.includes(ele._id) ? true : false;

																return (
																	<Grid item key={indexEle} xs={showTwoColumns ? 6: 12} style={{"paddingTop": "4px", textAlign: 'left'}}>
																		<CheckboxItem ele={ele} shouldChecked={shouldChecked} onChange={(e) => memoizedOnChangeCategory(e)}/>
																	</Grid>
																);
															})}
													</Grid>
												</FormGroup>
											</AccordionDetails>}
										</Accordion>
									)
								})}
							</AccordionDetails>
							}
						</Accordion>

						{includeTeacherCategory && (
							<Accordion onChange={(event, expanded) => onShowing('teacher', expanded)}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="panel3a-content"
									id="panel3a-header"
								>
									<Typography sx={{ width: '70%', flexShrink: 0 }}>Other</Typography>
									<Typography sx={{ color: 'primary.main' }}>{countItem['teacher'] ? `${countItem['teacher']} item(s) selected` : ''}</Typography>
								</AccordionSummary>
								{ showDetail['teacher'] && <AccordionDetails>
									{qualificationList.filter(item => item.type === 'teacher').map((item, index) => {
										return (
											<Accordion onChange={(event, expanded) => onShowing(`teacher_${item._id}`, expanded)} className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
												<AccordionSummary
													expandIcon={<ExpandMoreIcon />}
													aria-controls="panel1a1-content"
													id="panel1a1-header"
												>
													<Typography sx={{ width: '70%', flexShrink: 0 }}>{item.qualification_name}</Typography>
													<Typography sx={{ color: 'primary.main' }}>{countItem[item._id] ? `${countItem[item._id]} item(s) selected` : ''}</Typography>
												</AccordionSummary>
												{showDetail[`teacher_${item._id}`] && <AccordionDetails>
													<FormGroup>
														<Grid container spacing={2}>
															{item.qualifications
																// .filter((item) => item.type.includes('ge') && !item.whole_name.includes('All Levels'))
																.map((ele, indexEle) => {
																	const shouldChecked = selectedList.includes(ele._id) ? true : false;

																	return (
																		<Grid item key={indexEle} xs={showTwoColumns ? 6: 12} style={{"paddingTop": "4px", textAlign: 'left'}}>
																			<CheckboxItem ele={ele} shouldChecked={shouldChecked} onChange={(e) => memoizedOnChangeCategory(e)}/>
																		</Grid>
																	);
																})}
														</Grid>
													</FormGroup>
												</AccordionDetails>}
											</Accordion>
										)
									})}
								</AccordionDetails>
								}
							</Accordion>
						)}
					</>
				)
			}
			{/* <Accordion className='d-none'>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel4a-content"
					id="panel4a-header"
				>
					<Typography>Digital & Tech</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{techAndSMESCategories.filter(item => item.type === 'tech').map((item, index) => {
						return (
							<Accordion className='my-2' style={{ backgroundColor: "#f4f4f4" }}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls={`panel4a${index + 1}-content`}
									id={`panel4a${index + 1}-header`}
								>
									<Typography>{item.name}</Typography>
								</AccordionSummary>
								<AccordionDetails>
									{classList.filter(cl => cl.type.includes(item.value)).map(cl => {
										const shouldChecked = newSelectedList.includes(cl.key) ? true : false
										return (
											<FormControlLabel
												control={<Checkbox id={cl.key} value={cl.key} checked={shouldChecked} />}
												label={cl.whole_name}
												onChange={(e) => onChangeCategory(e)}
											/>
										)
									})}
								</AccordionDetails>
							</Accordion>
						)
					})}
				</AccordionDetails>
			</Accordion> */}

		</div>

	);
})

export default FilterAccordion
